export interface IMainInfo {
  max_members_amount: number;
  members_amount: number;
  max_space: number;
  total_document_size: number;
  total_document_count: number;
  members_amount_left: number;
};

export interface IInvitesInfo {
  sended: number;
  moved_to_registration: number;
  filled_the_details: number;
  registered: number;
  entered_room: number;
};

export interface ITempLinksItem {
  entityname: string;
  sender: string;
  recipient: string;
  viewed: number;
  downloaded: number;
};

export interface IUserActivityItem {
  email: string;
  user_name: string;
  action_cnt: number;
  file_actions_cnt: number;
  today_action_cnt: number;
  today_file_actions_cnt: number;
  last_visit: string;
};

export interface IDocsActivityItem {
  room_name: string;
  documents_count: number;
  new_documents: number;
  documents_actions: number;
  new_actions: number;
};

export interface IAgreementItem {
  awaiting_approval: number;
  rejected_approval: number;
  approved: number;
};

export interface ISigningItem {
  awaiting_signing: number;
  rejected_signing: number;
  signed: number;
};

// DEFAULT items
export const mainInfoDefault: IMainInfo = {
  max_members_amount: 0,
  members_amount: 0,
  max_space: 0,
  total_document_size: 0,
  total_document_count: 0,
  members_amount_left: 0,
}

export const invitesInfoDefault: IInvitesInfo = {
  sended: 0,
  moved_to_registration: 0,
  filled_the_details: 0,
  registered: 0,
  entered_room: 0,
}
